<template>
    <div id="profilePictureModal" class="modal fullscreen-modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">-
            <div class="modal-content">
                <div class="modal-header pb-3">
                    <h2 class="card-header-title font-weight-bold">
                        Photo de profil
                    </h2>
                    <button class="close close-profile text-dark" @click="close">
                        <i class="far fa-times" />
                    </button>
                </div>
                <div>
                    <div class="row form-group mx-0">
                        <div class="col bg-dark p-5">
                            <div class="avatar avatar-update-preview avatar-circle avatar-border-lg profile-cover-avatar my-0">
                                <label class="m-0 w-100">
                                    <input
                                        type="file"
                                        class="avatar-uploader-input"
                                        accept="image/*"
                                        data-test="form-profile-picture_file-input"
                                        @click="$event.target.value = ''"
                                        @change="fileSelected"
                                    >
                                    <img
                                        class="avatar-img w-100"
                                        :src="currentProfilePictureUrl"
                                        alt="Photo de profil actuelle"
                                        data-test="form-profile-picture_profile-picture"
                                    >
                                    <div class="image-edit-hover-block">
                                        <i class="fal fa-pen fal fa-pen w-100 fa-4x text-info" />
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer row mx-0 justify-content-center align-items-center">
                    <div class="col-12 col-sm" :class="currentProfilePictureUrl ? 'profile-delete-image-button' : 'hide-on-smallscreen'">
                        <template v-if="currentProfilePictureUrl && isProfilePictureSet">
                            <div
                                class="btn btn-link text-info font-weight-normal px-0 image-modification-button mb-9 mb-lg-0"
                                data-test="form-profile-picture_delete-picture"
                                @click="(_ => {resolvePromise({_delete: true}); close();})"
                            >
                                <i class="fal fa-trash-alt" />
                                Supprimer
                            </div>
                        </template>
                    </div>
                    <div class="col col-auto mobile-fixed-fullscreen-button d-flex">
                        <div
                            class="btn mb-0 hub-btn-outline-medium-grey image-modification-button"
                            data-test="form-profile-picture_cancel-picture"
                            @click.prevent="close"
                        >
                            Annuler
                        </div>
                        <div
                            class="ml-2 mb-0 btn btn-secondary image-modification-button"
                            data-test="form-profile-picture_submit-picture"
                            @click.prevent="close"
                        >
                            <i class="fal fa-check mr-1" />
                            <span>Valider</span>
                        </div>
                    </div>
                </div>
                <div id="profilePictureSubmodal" class="modal fullscreen-modal pt-3" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header pb-3">
                                <h2 class="card-header-title font-weight-bold">
                                    Modifier la photo
                                </h2>
                                <button class="close close-profile text-dark" @click="submodalClose">
                                    <i class="far fa-times" />
                                </button>
                            </div>
                            <div>
                                <form @submit.prevent="commitProfilePicture().then(_ => resolvePromise({form:profilePictureForm})).then(submodalClose)">
                                    <div class="row form-group m-0">
                                        <div class="col bg-dark p-5">
                                            <div class="row justify-content-center">
                                                <div class="col-auto p-0">
                                                    <div
                                                        :style="{
                                                            width: '230px',
                                                            height: '230px',
                                                        }"
                                                    >
                                                        <vue-avatar
                                                            ref="vueavatar"
                                                            :width="230"
                                                            :height="230"
                                                            :border="0"
                                                            :scale="parseFloat(scale)"
                                                            :rotation="parseInt(rotation)"
                                                        />
                                                        <img
                                                            class="opacity position-absolute top-0"
                                                            src="../../../public/img/circle-mask.svg"
                                                            style="pointer-events: none;"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-2 text-white text-center">
                                                Faites glisser pour repositionner la photo
                                            </div>
                                        </div>
                                    </div>
                                    <template v-if="formErrors.apiError">
                                        <div class="row form-group">
                                            <div class="col">
                                                <div class="invalid-feedback-color">
                                                    <i class="fal fa-exclamation-triangle" />
                                                    {{ formErrors.apiError }}
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <div class="row m-0 bg-dark text-white picture-preview-separator py-3">
                                        <div class="col">
                                            <label class="w-100">
                                                <div class="row">
                                                    <div class="col mb-2">
                                                        Zoom
                                                    </div>
                                                    <div class="col-auto">
                                                        {{ scale }}
                                                    </div>
                                                </div>
                                                <input
                                                    v-model="scale"
                                                    class="custom-range"
                                                    type="range"
                                                    min="1"
                                                    max="3"
                                                    step="0.02"
                                                    data-test="form-profile-picture_picture-editor_zoom-input"
                                                >
                                            </label>
                                        </div>
                                        <div class="col">
                                            <label class="w-100">
                                                <div class="row">
                                                    <div class="col mb-2">
                                                        Redresser
                                                    </div>
                                                    <div class="col-auto">
                                                        {{ rotation }}
                                                    </div>
                                                </div>
                                                <input
                                                    v-model="rotation"
                                                    class="custom-range"
                                                    type="range"
                                                    min="-60"
                                                    max="60"
                                                    step="1"
                                                    data-test="form-profile-picture_picture-editor_rotation-input"
                                                >
                                            </label>
                                        </div>
                                        <div class="col-auto text-center">
                                            <button class="bg-transparent border-0" @click="resetImagePosition()">
                                                <i class="fal fa-redo-alt text-white" />
                                            </button>
                                        </div>
                                    </div>
                                    <footer class="row my-4 mx-0">
                                        <div class="col" />
                                        <div class="col col-auto mobile-fixed-fullscreen-button d-flex">
                                            <div
                                                class="btn hub-btn-outline-medium-grey"
                                                @click="submodalClose"
                                            >
                                                Annuler
                                            </div>
                                            <button
                                                class="ml-2 btn btn-secondary"
                                                type="submit"
                                                :disabled="isLoading"
                                                data-test="form-profile-picture_picture-editor_submit"
                                            >
                                                <i class="fal fa-check" />
                                                Enregistrer
                                            </button>
                                        </div>
                                    </footer>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {VueAvatar} from 'vue-avatar-editor-improved';
import {delay} from 'lodash';

export default {
    components: {
        VueAvatar,
    },
    data () {
        return {
            isProfilePictureSet: undefined,
            profilePictureForm: undefined,
            currentProfilePictureUrl: undefined,
            scale: undefined,
            rotation: undefined,
            formErrors: {
                apiError: false,
            },
            resolvePromise: null,
            rejectPromise: null,
            isLoading: false,
        };
    },
    methods: {
        open ({callback, userForm}) {
            this.isLoading = false;
            return new Promise((resolve, reject) => {
                $('#profilePictureModal').modal('show');

                this.profilePictureForm = new FormData();
                this.currentProfilePictureUrl = userForm.profilePictureUrl;
                this.isProfilePictureSet = userForm.isProfilePictureSet;

                this.resolvePromise = async (params) => {
                    try {
                        await callback(params);
                        resolve(params);
                    } catch (error) {
                        throw this.formErrors.apiError = error;
                    }
                };
                this.rejectPromise = reject;
            });
        },
        fileSelected (e) {
            if (!(e.target.files || e.dataTransfer.files).length) {
                // no file selected
                return;
            }

            delete this.formErrors.apiError;
            $('#profilePictureSubmodal').modal('show');
            this.scale = 1.0;
            this.rotation = 0.0;
            const file = e.target.files[0];
            delay((_) => {
                this.$refs.vueavatar.fileSelected(e);
                this.$emit('image-selected', file);
            });
        },
        commitProfilePicture () {
            this.isLoading = true;
            return new Promise(resolve =>
                this.$refs.vueavatar
                    .getImageScaled()
                    .toBlob((blob) => {
                        this.profilePictureForm.append('image', blob);
                        this.profilePictureForm.append('url', URL.createObjectURL(blob));
                        this.$emit('image-selected', new File([blob], "file"));
                        resolve();
                        this.close();
                    }),
            );
        },
        resetImagePosition () {
            this.scale = 1;
            this.rotation = 0;
        },
        close () {
            $('#profilePictureModal').modal('hide');
        },
        submodalClose () {
            $('#profilePictureSubmodal').modal('hide');
        },
    },
};
</script>

<style scoped>
.avatar-update-preview {
    width: 15rem;
    height: 15rem;
    min-width: 15rem;
    min-height: 15rem;
}

.picture-preview-separator {
    border-top: 0.5px solid rgba(139, 139, 139, 0.6);
}

input[type=range]::-webkit-slider-thumb {
    background: #c02942;
    border: 0.5px solid #f4f4f4;
    width: 20px;
    height: 20px;
    margin-top: -9px;
}

input[type=range]::-webkit-slider-runnable-track {
    height: 3px;
    background: rgba(139, 139, 139, 0.6);
}

input[type=range]::-moz-range-thumb {
    background: #c02942;
    border: 0.5px solid #f4f4f4;
    width: 20px;
    height: 20px;
    margin-top: -9px;
}

input[type=range]::-moz-range-track {
    height: 3px;
    background: rgba(139, 139, 139, 0.6);
}

input[type=range]::-ms-thumb {
    background: #c02942;
    border: 0.5px solid #f4f4f4;
    width: 20px;
    height: 20px;
    margin-top: -9px;
}

input[type=range]::-ms-track {
    height: 3px;
    background: rgba(139, 139, 139, 0.6);
}

input[type=range]::-ms-fill-lower {
    background: #c02942;
}

input[type=range]::-moz-range-progress {
    background: #c02942;
}

.image-edit-hover-block {
    visibility: hidden;
    position: absolute;
    display: flex;
    top: 0;
    right: 0;
    background: rgba(255, 255, 255, 0);
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    text-align: center;
    align-items: center;
    cursor: pointer;
}

.avatar-update-preview:hover .image-edit-hover-block {
    background: rgba(255, 255, 255, 0.75);
    transition: all 0.2s ease;
    visibility: visible;
}

@media screen and (max-width: 576px) {
    .image-modification-button {
        width: 100%;
        margin-bottom: 1rem;
        margin-left: 0;
    }

    .picture-preview-separator {
        flex-direction: column;
    }

    .profile-delete-image-button {
        text-align: center;
        margin-bottom: 1rem;
        width: 100%;
    }
}
</style>
